import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/* The graph's legend, as the design writes it: the two directions a path can run, an inferred edge
 * nobody has accepted, a dataset no harvest has catalogued, and a dataset nothing has scored.
 *
 * **The inferred count is the review queue's**, said beside the dashed line, because an inferred
 * edge is excluded from every walk until a person accepts it — the picture cannot show it, and the
 * count is how a reader learns there is something waiting to be decided. `null` while the queue has
 * not answered, so the legend never claims nought about a read it does not have.
 */
export function LineageLegend({
  inferred,
}: {
  readonly inferred: number | null;
}): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="lq-legend">
      <span className="lq-legend__item">
        <span className="lq-legend__line lq-legend__line--up" aria-hidden="true" />
        {t('lineage.legend.upstream')}
      </span>
      <span className="lq-legend__item">
        <span className="lq-legend__line lq-legend__line--down" aria-hidden="true" />
        {t('lineage.legend.downstream')}
      </span>
      <span className="lq-legend__item">
        <span className="lq-legend__line lq-legend__line--inferred" aria-hidden="true" />
        {inferred === null
          ? t('lineage.legend.inferredUncounted')
          : t('lineage.legend.inferred', { count: inferred })}
      </span>
      <span className="lq-legend__item">
        <span className="lq-legend__box" aria-hidden="true" />
        {t('lineage.legend.uncatalogued')}
      </span>
      <span className="lq-legend__item">
        <span className="lq-legend__ring" aria-hidden="true" />
        {t('lineage.legend.unscored')}
      </span>
    </div>
  );
}
